import './_product-customizer-card-form.scss';
import component from './product-customizer-card-form';

export default component;
